import { render, staticRenderFns } from "./default-spec-panel.vue?vue&type=template&id=1c1a43ec&scoped=true&"
import script from "./default-spec-panel.vue?vue&type=script&lang=js&"
export * from "./default-spec-panel.vue?vue&type=script&lang=js&"
import style0 from "./default-spec-panel.vue?vue&type=style&index=0&id=1c1a43ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a43ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c1a43ec')) {
      api.createRecord('1c1a43ec', component.options)
    } else {
      api.reload('1c1a43ec', component.options)
    }
    module.hot.accept("./default-spec-panel.vue?vue&type=template&id=1c1a43ec&scoped=true&", function () {
      api.rerender('1c1a43ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/default-spec-panel.vue"
export default component.exports